'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_AppRegisteredUser$$anon$27(evaluator$20) {
  this.Lapp_data_AppRegisteredUser$$anon$27__f_evaluator$10 = null;
  this.Lapp_data_AppRegisteredUser$$anon$27__f_evaluator$10 = evaluator$20;
}
export { $c_Lapp_data_AppRegisteredUser$$anon$27 as $c_Lapp_data_AppRegisteredUser$$anon$27 };
$c_Lapp_data_AppRegisteredUser$$anon$27.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_AppRegisteredUser$$anon$27.prototype.constructor = $c_Lapp_data_AppRegisteredUser$$anon$27;
/** @constructor */
function $h_Lapp_data_AppRegisteredUser$$anon$27() {
}
export { $h_Lapp_data_AppRegisteredUser$$anon$27 as $h_Lapp_data_AppRegisteredUser$$anon$27 };
$h_Lapp_data_AppRegisteredUser$$anon$27.prototype = $c_Lapp_data_AppRegisteredUser$$anon$27.prototype;
$c_Lapp_data_AppRegisteredUser$$anon$27.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_data_AppRegisteredUser$$anon$27.prototype.apply__s_Option = (function() {
  var v = this.Lapp_data_AppRegisteredUser$$anon$27__f_evaluator$10.apply__O();
  return (((typeof v) === "boolean") ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(v) : $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
});
$c_Lapp_data_AppRegisteredUser$$anon$27.prototype.apply__O = (function() {
  return this.apply__s_Option();
});
var $d_Lapp_data_AppRegisteredUser$$anon$27 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_AppRegisteredUser$$anon$27, "app.data.AppRegisteredUser$$anon$27", ({
  Lapp_data_AppRegisteredUser$$anon$27: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_data_AppRegisteredUser$$anon$27 as $d_Lapp_data_AppRegisteredUser$$anon$27 };
//# sourceMappingURL=app.data.-App-Registered-User$$anon$27.js.map
